import axios from 'axios';
import { stringify } from 'qs';
import { success, failed } from '@/api/modules/auth/interceptorCallbacks.js';



const authClientProxy = axios.create({
  baseURL: import.meta.env.VITE_CHOCO_API,
  paramsSerializer: stringify,
  transformRequest: [data => JSON.stringify(data)],
  headers: {
    'Content-Type': 'application/json',
  },
});

const authClientChoco = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  paramsSerializer: stringify,
  transformRequest: [data => JSON.stringify(data)],
  headers: {
    'Content-Type': 'application/json',
  },
});

authClientProxy.interceptors.response.use(success, failed);
authClientChoco.interceptors.response.use(success, failed);

export { authClientProxy, authClientChoco };
